import { Card, CardContent, makeStyles, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'

const useStyles = makeStyles({
    card: {
        borderRadius: 0,
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        borderBottomColor: "rgba(0, 0, 0, 0.12)",
        position: "fixed",
        marginLeft: "270px",
        left: 0,
        right: 0,
        top: "139px",
        zIndex: 1200,
        "@media only screen and (max-width: 960px)": {
            marginLeft: 0
        }
    },
    text : {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
    }
})

function HelpCard(props) {
    const classes = useStyles()

    return (
        <Card elevation={0} className={classes.card}>
            <CardContent>
                <Typography className={classes.text} align="center" variant="body1">{props.message}</Typography>
            </CardContent>
        </Card>
    )
}

HelpCard.propTypes = {
    message: PropTypes.string.isRequired
}

export default HelpCard
